// utils/useTrackOpen.ts
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../../../features/userSlice";
import { getLastLocation } from "../../../../../../../utils/ReferrerTracker";
import { postAnalyticsTracking } from "../../../../../../../logic/actionTracking/trackingHelper";

export const useTrackOpen = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as string;

  const trackOpen = (actionId: string) => {
    const location = getLastLocation();
    const from = location?.pathname
      ? window.location.origin + location.pathname + location.search
      : window.location.origin;
    postAnalyticsTracking(
      {
        origin_path: from,
        target_path: window.location.href,
        action_id: actionId,
      },
      oauthTokenHeader,
    );
  };

  return trackOpen;
};
